import Container from 'react-bootstrap/Container';

const PHASES = [
  {
    title: 'Before Program',
    items: ['Career Network onboarding', 'Pre-Program onboarding', 'Coach introduction'],
    goal: 'Build excitement and prepare students before HQ opens.',
  },
  {
    title: 'Program Kickoff',
    items: ['Welcome onboarding', 'HQ access support', 'LiveLab preparation'],
    goal: 'Drive first login and first-week engagement.',
  },
  {
    title: 'Activation Monitoring',
    items: ['HQ login reminders', 'LiveLab attendance nudges', 'Early intervention support'],
    goal: 'Identify disengagement before students fall behind.',
  },
  {
    title: 'Completion & Outcomes',
    items: ['Final performance review', 'Part 2 invites', 'Completion support', 'Certification outreach'],
    goal: null,
  },
];

const ACADEMIC_SUPPORT = [
  'Milestone (weekly assignment) reminders',
  'LiveLab attendance alerts',
  'Low engagement outreach',
  'Drop-in encouragement',
  'LiveLab-specialist support',
  'Coach outreach',
];

export default function Outreach() {
  return (
    <Container className="py-5" style={{ maxWidth: '1100px' }}>
      <div className="row g-4">
        <div className="col-lg-8">
          <div className="bg-white px-5 py-5 rounded-3 shadow-sm">
            <header className="text-center mb-5">
              <h1
                className="fw-bold mb-3"
                style={{
                  fontFamily: 'Georgia, "Times New Roman", serif',
                  fontSize: '2.25rem',
                }}
              >
                Student Outreach &amp; Intervention
              </h1>
              <p
                className="text-muted mx-auto mb-0"
                style={{ maxWidth: '620px', fontSize: '1rem', lineHeight: 1.55 }}
              >
                Students receive proactive onboarding, engagement, and intervention
                support throughout the program lifecycle. Communications adapt based
                on activation status, attendance, participation, and academic
                engagement signals.
              </p>
            </header>

            {PHASES.map((phase, idx) => (
              <div key={phase.title}>
                <PhaseCard {...phase} index={idx} />
                {phase.goal && <GoalBlock text={phase.goal} />}
                {idx < PHASES.length - 1 && (
                  <div className="d-flex justify-content-center my-4">
                    <div className="border-start border-2" style={{ height: '32px' }} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="col-lg-4">
          <div
            className="bg-white rounded-3 p-4 shadow-sm"
            style={{ position: 'sticky', top: '1rem' }}
          >
            <h2
              className="fw-bold mb-3 text-primary-emphasis"
              style={{
                fontFamily: 'Georgia, "Times New Roman", serif',
                fontSize: '1.6rem',
              }}
            >
              Academic Support
            </h2>
            <div
              className="text-uppercase text-secondary mb-2"
              style={{ letterSpacing: '0.06em', fontSize: '0.78rem' }}
            >
              Students may receive
            </div>
            <hr className="opacity-25" />
            <ul className="list-unstyled mb-4" style={{ fontSize: '0.98rem', lineHeight: 1.7 }}>
              {ACADEMIC_SUPPORT.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <div
              className="text-uppercase text-secondary mb-2"
              style={{ letterSpacing: '0.06em', fontSize: '0.78rem' }}
            >
              Goal
            </div>
            <hr className="opacity-25" />
            <p
              className="mb-0 fst-italic"
              style={{ fontSize: '0.98rem', lineHeight: 1.5, color: '#6c757d' }}
            >
              Re-engage at-risk students throughout the program.
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
}

function PhaseCard({ title, items, index }) {
  return (
    <div className="text-center">
      <span
        className="badge text-bg-primary-subtle text-primary-emphasis text-uppercase mb-2"
        style={{ letterSpacing: '0.08em', fontSize: '0.72rem' }}
      >
        Phase {index + 1}
      </span>
      <h3
        className="fw-bold mb-3"
        style={{
          fontFamily: 'Georgia, "Times New Roman", serif',
          fontSize: '1.45rem',
        }}
      >
        {title}
      </h3>
      <ul className="list-unstyled" style={{ fontSize: '1rem', lineHeight: 1.7 }}>
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
}

function GoalBlock({ text }) {
  return (
    <div className="text-center my-4">
      <div
        className="fw-bold text-uppercase mb-1"
        style={{ letterSpacing: '0.08em', fontSize: '0.85rem', color: '#6c757d' }}
      >
        Goal
      </div>
      <hr className="mx-auto opacity-25" style={{ maxWidth: '180px' }} />
      <p
        className="fst-italic mb-0"
        style={{ fontSize: '1rem', color: '#6c757d' }}
      >
        {text}
      </p>
    </div>
  );
}
